import React, {
} from 'react';
import {DataGrid} from '@material-ui/data-grid';
import SettingRepository from "../../../repositories/SettingRepository";
import {
    ActionButtons,
    ActionButtonTypes,
    buildActionButton
} from "../../../components/Grid/Columns";
import {useNavigate} from "react-router";
import Header from "./Header";
import {useGrid} from "../../../hooks/crud/Grid";
import {FilterBar} from "../../../components/Grid/FilterBar";
import {useTranslation} from "react-i18next";
import {GridSkeleton} from "../../../components/GridSkeleton";

const SettingListView = () => {

	const navigate = useNavigate();
	const repository = new SettingRepository();
	const {t}  = useTranslation();

	const sortOptions = [
      {
          value: 'Name|desc',
          label: t('Name') + ' (A-Z)'
      },
      {
          value: 'Name|asc',
          label: t('Name') + ' (Z-A)'
      }
    ];

    const handleEditItemClick = (event) => {
	    navigate("/app/settings/" + event.Id);
    }

	const { items, totalCount, itemsOnPage, onEditHandler, onPage, isSearching, onFilterChangedHandler , onSortChangedHandler, filter, sort, updateGrid } = useGrid(repository, { onEdit: handleEditItemClick, defaultSort: sortOptions[0].value });

	const columns = [
        { field: 'Id', headerName: t('ID'), width: 300, sortable: false },
        { field: 'Value', headerName: t('Value'), width: 300, sortable: false },
        {
          headerName: t('Actions'),
          field: 'edit',
          ...ActionButtons([buildActionButton(ActionButtonTypes.EDIT, t("Edit"), onEditHandler)])
        }
    ];

	return (
	    <GridSkeleton title={t("Settings")}
                      isSearching={isSearching}
                      header={(<Header onRefresh={updateGrid} />)}
                      filter={(<FilterBar sortOptions={sortOptions} onFilterChanged={onFilterChangedHandler} onSortChanged={onSortChangedHandler} filter={filter} sort={sort} showQuerySearch={false} />)}
                      grid={(<DataGrid
                                   disableMultipleSelection={true}
                                   disableColumnFilter={true}
                                   rows={items()}
                                   rowCount={totalCount()}
                                   columns={columns}
                                   pageSize={itemsOnPage}
                                   paginationMode="server"
                                   sortingMode="server"
                                   disableColumnSelector={true}
                                   disableSelectionOnClick={true}
                                   disableColumnMenu={true}
                                   onPageChange={onPage}
                                   rowsPerPageOptions={[itemsOnPage]}
                                   hideFooterSelectedRowCount={true}
                         />)}
        />

	);
};

export default SettingListView;